// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1WWaF","title":"AfterFrontImage_title__ZW_7J"};